package com.klantenstop.web.pages.admin.companies.manage

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.klantenstop.web.components.layout.AdminPageLayout
import com.materialkobweb.utils.rememberViewModel
import com.materialkobweb.utils.Logger
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.coroutines.flow.collectLatest
import org.jetbrains.compose.web.css.px

@Page("/admin/bedrijven/beheren")
@Composable
fun ManageCompanyPage() {
    val ctx = rememberPageContext()
    val companyId = ctx.route.params["id"]
    val viewModel = rememberViewModel { ManageCompanyViewModel(companyId) }
    val state by viewModel.state.collectAsState()
    val isEdit = companyId != null

    LaunchedEffect(Unit) {
        viewModel.effect.collectLatest { effect ->
            when (effect) {
                is ManageCompanyContract.Effect.NavigateBack -> {
                    // TODO: Navigate back to companies list
                    Logger.debug("ManageCompanyPage", "Navigate back to companies")
                }

                is ManageCompanyContract.Effect.ShowError -> {
                    // TODO: Show error snackbar/toast
                    Logger.error("ManageCompanyPage", effect.message)
                }

                is ManageCompanyContract.Effect.ShowSuccess -> {
                    // TODO: Show success snackbar/toast
                    Logger.info("ManageCompanyPage", effect.message)
                }
            }
        }
    }

    AdminPageLayout(
        title = if (isEdit) "Edit Company" else "Create Company"
    ) {
        ManageCompanyContent(
            state = state,
            sendIntent = viewModel::sendIntent
        )
    }
}

@Composable
fun ManageCompanyContent(
    state: ManageCompanyContract.State,
    sendIntent: (ManageCompanyContract.Intent) -> Unit
) {
    val colorMode = ColorMode.current
    val isEdit = state.company != null

    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(40.px),
        verticalArrangement = Arrangement.spacedBy(20.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SpanText(
            text = if (isEdit) "Edit Company" else "Create Company",
            modifier = Modifier
                .fontSize(32.px)
                .fontWeight(FontWeight.Bold)
                .color(if (colorMode.isLight) Colors.Black else Colors.White)
        )

        SpanText(
            text = if (isEdit) "Company ID: ${state.company?.id}" else "Fill in the details to create a new company",
            modifier = Modifier
                .fontSize(18.px)
                .fontWeight(FontWeight.Normal)
                .color(if (colorMode.isLight) Colors.Gray else Colors.LightGray)
        )

        if (state.isLoading) {
            SpanText(
                text = "Loading...",
                modifier = Modifier
                    .fontSize(16.px)
                    .color(if (colorMode.isLight) Colors.Gray else Colors.LightGray)
            )
        }

        // TODO: Add form fields (name, description, address, phone, email, website, etc.)
        // TODO: Add logo/image upload
        // TODO: Add categories selection
        // TODO: Add status selection
        // TODO: Add opening hours editor
        // TODO: Add save/update button
        // TODO: Add cancel button
    }
}




